import React, {useMemo} from "react";
import {useTheme} from "styled-components";
import {
  ResponsiveProductCard,
  ProductCard,
  HorizontalProductCard,
  CartIconActions,
  SaleIndicator,
} from "@ui";
import useProductCard from "src/core/products/hooks/useProductCard";
import styles from "src/themes/baseTheme/components/ProductCard/styles";
import Product from "src/core/common/models/product";
import useSite from "src/core/sites/hooks/useSite";
import {getFlowerTypeIndicatorProps} from "src/themes/baseTheme/elements/flowerType";

export default function BaseThemeProductCard({product, ...props}) {
  const site = useSite();
  const _product = product instanceof Product ? product : new Product(product);
  const {actionProps, cartProps, ...productCardProps} = useProductCard(_product);
  const theme = useTheme();

  const flowerTypeIndicatorProps = getFlowerTypeIndicatorProps(site);

  const DesktopProductCard = useMemo(
    () => (
      <div>
        <ProductCard
          {...props}
          {...productCardProps}
          product={product}
          styles={styles(theme, site, {mode: props.mode})}
          potencyTagsPosition="bottom"
          flowerTypeIndicatorProps={flowerTypeIndicatorProps}
          ActionsComponent={(props) => <CartIconActions {...props} {...actionProps} />}
          SaleIndicatorComponent={(props) =>
            productCardProps.onSale && <SaleIndicator {...props} position={"left"} />
          }
        />
      </div>
      // eslint-disable-next-line
    ),
    [props, productCardProps, product, theme, site, flowerTypeIndicatorProps, actionProps]
  );

  const MobileProductCard = useMemo(
    () => (
      <div>
        <HorizontalProductCard
          {...props}
          {...productCardProps}
          styles={styles(theme, site, {isHorizontalInMobile: true})}
          showSizes
          potencyTagsPosition="bottom"
          flowerTypeIndicatorProps={flowerTypeIndicatorProps}
          ActionsComponent={(props) => <CartIconActions {...actionProps} {...props} />}
          SaleIndicatorComponent={(props) =>
            productCardProps.onSale && <SaleIndicator {...props} position={"right"} />
          }
        />
      </div>
      // eslint-disable-next-line
    ),
    [props, productCardProps, theme, site, flowerTypeIndicatorProps, actionProps]
  );

  return (
    <ResponsiveProductCard
      DesktopProductCard={DesktopProductCard}
      TabletProductCard={DesktopProductCard}
      MobileProductCard={props.mode === "small" ? DesktopProductCard : MobileProductCard}
    />
  );
}
